import { Contract } from './types'

// Mock data for demo purposes
export const mockContracts: Contract[] = [
  {
    id: 1,
    contract_number: 'CONTRACT № 55/TR-AB-LED/2025 din 20/11/2025',
    title: 'CONTRACT № 55/TR-AB-LED/2025 din 20/11/2025',
    status: 'signed',
    created_at: '2024-01-15T10:30:00Z',
    signed_at: '2024-01-20T14:15:00Z',
    deadline_at: '2024-12-31T23:59:59Z',
    pdf_url:
      'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    id: 2,
    contract_number: 'CONTRACT № 56/TR-AB-LED/2025 din 15/12/2025',
    title: 'CONTRACT № 56/TR-AB-LED/2025 din 15/12/2025',
    status: 'pending',
    created_at: '2024-01-20T14:15:00Z',
    deadline_at: '2024-06-30T23:59:59Z',
    pdf_url:
      'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    id: 3,
    contract_number: 'CONTRACT № 57/TR-AB-LED/2025 din 10/01/2026',
    title: 'CONTRACT № 57/TR-AB-LED/2025 din 10/01/2026',
    status: 'draft',
    created_at: '2024-01-25T16:20:00Z',
    deadline_at: '2024-08-15T23:59:59Z',
    pdf_url:
      'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    id: 4,
    contract_number: 'CONTRACT № 58/TR-AB-LED/2025 din 05/02/2026',
    title: 'CONTRACT № 58/TR-AB-LED/2025 din 05/02/2026',
    status: 'signed',
    created_at: '2024-01-10T09:00:00Z',
    signed_at: '2024-01-18T11:30:00Z',
    deadline_at: '2024-12-31T23:59:59Z',
    pdf_url:
      'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    id: 5,
    contract_number: 'CONTRACT № 54/TR-AB-LED/2025 din 25/10/2025',
    title: 'CONTRACT № 54/TR-AB-LED/2025 din 25/10/2025',
    status: 'expired',
    created_at: '2023-12-20T13:10:00Z',
    signed_at: '2023-12-25T10:00:00Z',
    deadline_at: '2024-01-25T23:59:59Z',
    pdf_url:
      'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  }
]
